<template>
	<nav
		class="pagination is-centered is-small"
		role="navigation"
		aria-label="pagination"
		style="margin-top: 15px"
	>
		<a
			class="pagination-previous"
			:disabled="disablePrevious"
			v-if="isMobile"
			@click="disablePrevious ? null : paginate(1)"
		>
			<i
				v-if="isMobile" class="fas fa-step-backward"
			/></a>
		<a
			class="pagination-previous"
			:disabled="disablePrevious"
			@click="disablePrevious ? null : paginate(getCurrentPage - 1)"
		>
			<i
				class="fas fa-play flip"
			/></a>
		<div v-if="!isMobile" class="pagination-list" style="color: white">
			<a
				class="pagination-link"
				v-if="getCurrentPage > 1"
				@click="paginate(1)"
				:style="comLeftMargin"
			>1</a
			>
			<div class="pagination-ellipsis" v-if="getCurrentPage > 3">
				&hellip;
			</div>
			<a class="pagination-link" v-if="getCurrentPage > 2" @click="paginate(getCurrentPage - 1)">
				{{ getCurrentPage - 1 }}
			</a>
			<a class="pagination-link is-current" :style="comCenterMargin">
				{{ getCurrentPage }}
			</a>
			<a class="pagination-link" v-if="getCurrentPage < pagination.totalPages - 1" @click="paginate(getCurrentPage + 1)">
				{{ getCurrentPage + 1 }}
			</a>
			<div
				class="pagination-ellipsis"
				v-if="getCurrentPage < pagination.totalPages - 2"
			>
				&hellip;
			</div>
			<a class="pagination-link" v-if="getCurrentPage != pagination.totalPages && pagination.totalPages > 0"
				@click="paginate(pagination.totalPages)"
				:style="comRightMargin"
			>{{ pagination.totalPages }}</a>
		</div>
		<div class="pagination-next page-size">
			<div v-if="!isMobile" style="padding-right: 10px;">{{ $t('pagination.pageSizeLabel') }}</div>
			<div class="select">
				<select @change="updatePageSize" v-model="pagination.pageSize">
					<option>10</option>
					<option>25</option>
					<option>50</option>
					<option>100</option>
				</select>
			</div>
		</div>
		<a
			class="pagination-next"
			:disabled="disableNext"
			@click="disableNext ? null : paginate(getCurrentPage + 1)"
		><i class="fas fa-play" />
		</a>
		<a
			class="pagination-next"
			:disabled="disableNext"
			@click="disableNext ? null : paginate(pagination.totalPages)"
			v-if="isMobile"
		>
			<i v-if="isMobile" class="fas fa-step-forward" />
		</a>
	</nav>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	props: {
		pagination: {
			type: Object,
			required: true
		}
	},
	computed: {
		...mapGetters('appStore', ['isMobile']),
		getCurrentPage() {
			if ('currentPage' in this.pagination) {
				return this.pagination.currentPage;
			}

			if ('pageNumber' in this.pagination) {
				return this.pagination.pageNumber;
			}

			return 1;
		},

		disableNext() {
			return this.getCurrentPage < this.pagination.totalPages ? false : true;
		},

		disablePrevious() {
			return this.getCurrentPage > 1 ? false : true;
		},

		comRightMargin() {
			let margin =
        114 - (this.pagination.totalPages - this.getCurrentPage) * 38;

			if (this.getCurrentPage >= this.pagination.totalPages - 2) {
				return `margin-right: ${margin}px`;
			} else {
				return 'margin-right: 0';
			}
		},
		comLeftMargin() {
			let margin = 38 + (3 - this.getCurrentPage) * 38;

			if (this.getCurrentPage < 4) {
				return `margin-left: ${margin}px`;
			} else {
				return 'margin-left: 0';
			}
		},
		comCenterMargin() {
			if (this.pagination.totalPages == 1) {
				return 'margin: 0';
			} else if (this.getCurrentPage == 1) {
				return 'margin-left: 114px';
			} else if (this.getCurrentPage == this.pagination.totalPages) {
				return 'margin-right: 114px';
			} else {
				return '';
			}
		}
	},

	methods: {
		paginate(page) {
			this.$emit('paginate', page);
		},
		updatePageSize() {
			this.$emit('updatePageSize', this.pagination.pageSize);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/colors.scss";

.pagination {
  position: relative;
  padding-bottom: 35px;
}
.pagination-next.page-size {
  background-color: transparent;
  border-color: transparent !important;
  color: $dark !important;
  box-shadow: none !important;
  position: absolute;
  right: -11px;
  top: 35px;
}
.pagination-next.page-size .select {
  color: $dark !important;
  select {
    background-color: white;
  }
}
.pagination-next,
.pagination-previous {
  background-color: $pagnation-backround-color;
}
.pagination-link {
  background-color: $pagination-link-background-color;
}
.pagination-ellipsis {
  width: 30px;
  top: 7px;
}
.fas.flip {
  transform: scaleX(-0.8);
}
.fa-play {
  transform: scaleX(0.8);
}
.fa-step-forward,
.fa-step-back {
  transform: scaleX(1.5);
}
.select::after {
  z-index: 1 !important;
}
</style>
